import React from 'react';
import { useTranslation } from 'react-i18next';
import UntypedModal from '../../Modal';
import UntypedShare from '../../ExportReportPopup/share';

const Modal = UntypedModal as unknown as React.FC<{
  isVisible: boolean;
  title: React.ReactNode;
  content: React.ReactNode;
  onClose: () => void;
  doNotCloseOnOutsideClick?: boolean;
}>;

const Share = UntypedShare as unknown as React.FC<{
  customDashboardId: string;
}>;

interface ShareDashboardModalProps {
  isVisible: boolean;
  dashboardId: string;
  onClose: () => void;
}

// Same share-link form cases and reports use (validity period, optional
// password, generated link); only the target differs.
export const ShareDashboardModal: React.FC<ShareDashboardModalProps> = ({
  isVisible,
  dashboardId,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isVisible={isVisible}
      title={t('Share dashboard')}
      doNotCloseOnOutsideClick={true}
      content={
        // the share form's layout styles (ExportReportPopup/index.css) are
        // scoped to the tab body the case modal renders it in
        <div className="tab-content">
          <Share
            key={`share_dashboard_${dashboardId}`}
            customDashboardId={dashboardId}
          />
        </div>
      }
      onClose={onClose}
    />
  );
};
